
import { Component, Vue } from 'vue-property-decorator';
import { getApiUrl } from '@/helpers/apiUrl';

@Component
export default class DesktopApp extends Vue {
  downloading = {
    windows: false,
    mac: false
  };

  async downloadWindows() {
    this.downloading.windows = true;
    try {
      const response = await fetch(getApiUrl('/api/downloads/desktop/windows'), {
        headers: {
          'Authorization': `Bearer ${this.$store.state.authentication.token}`
        }
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'TeamLeader OES Setup.exe';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        this.$store.dispatch('globalState/showSnackbar', {
          message: 'Windows installer not available',
          color: 'error'
        });
      }
    } catch (error) {
      this.$store.dispatch('globalState/showSnackbar', {
        message: 'Failed to download installer',
        color: 'error'
      });
    } finally {
      this.downloading.windows = false;
    }
  }

  async downloadMac() {
    this.downloading.mac = true;
    try {
      const response = await fetch(getApiUrl('/api/downloads/desktop/mac'), {
        headers: {
          'Authorization': `Bearer ${this.$store.state.authentication.token}`
        }
      });
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'TeamLeader OES.dmg';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      } else {
        this.$store.dispatch('globalState/showSnackbar', {
          message: 'macOS installer not available',
          color: 'error'
        });
      }
    } catch (error) {
      this.$store.dispatch('globalState/showSnackbar', {
        message: 'Failed to download installer',
        color: 'error'
      });
    } finally {
      this.downloading.mac = false;
    }
  }
}
